module.exports = __webpack_public_path__ + "static/media/Delonghi.8f7f3185.jpg";